export enum OrganizationUserType {
    Owner = 0,
    Admin = 1,
    User = 2,
    Manager = 3,
}
